// Día siguiente a una fecha YYYY-MM-DD, calculado en UTC puro: no depende de
// la zona horaria ni de la hora del navegador.
export function siguienteDiaIso(fechaIso: string): string {
  const d = new Date(`${fechaIso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
}
